import { render, staticRenderFns } from "./ShippingUnits.vue?vue&type=template&id=d7cc9ea6"
import script from "./ShippingUnits.vue?vue&type=script&lang=js"
export * from "./ShippingUnits.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports